define('modules/editor/views/elements/popup',['require','exports','module','./element','../../models/editorstate'],function(require, exports, module){
  "use strict";
  var Element = require("./element"),
      EditorState = require("../../models/editorstate");

  module.exports = Element.extend({
    className: "ed-panel-item ed-item-popup",
    onEditContent: function(e){
      //call editor service
      this.model.editPopup();
    },
    onRender: function(){
      var htmlContent;
      if(EditorState.isGenerateMode()){
        htmlContent = this.model.getPropertyGroup("popup:content").get("content");
        this.$el.html(htmlContent);
      }
      else {
        this.$el.html("");
      }
    }
  });
});


